export const agentAttorneyMappingTo9142BSectionE = {
  name: "Agent/Attorney Profile Form Mapping",
  machine_name: "agent_attorney_9142B_profile_mapping",
  targetFormDetailName: "Form ETA-9142B",
  targetSectionName: "Attorney or Agent Information <br/>(if applicable)",
  targetSectionLabel: "E",
  fields: [
    {
      profileFieldName: "new_profile_individual_agent_type_id",
      formTargetField: "attyRepresentType",
    },
    {
      profileFieldName: "new_profile_individual_agent_last_name",
      formTargetField: "attyLastname",
    },
    {
      profileFieldName: "new_profile_individual_agent_first_name",
      formTargetField: "attyFirstname",
    },
    {
      profileFieldName: "new_profile_individual_agent_middle_name",
      formTargetField: "attyMiddlename",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_1",
      formTargetField: "attyAddr1",
    },
    {
      profileFieldName: "new_profile_individual_agent_address_2",
      formTargetField: "attyAddr2",
    },
    {
      profileFieldName: "new_profile_individual_agent_city",
      formTargetField: "attyCity",
    },
    {
      profileFieldName: "new_profile_individual_agent_state_id",
      formTargetField: "attyState",
    },
    {
      profileFieldName: "new_profile_individual_agent_zip",
      formTargetField: "attyPostcode",
    },
    {
      profileFieldName: "new_profile_individual_agent_country_id",
      formTargetField: "attyCountry",
    },
    {
      profileFieldName: "new_profile_individual_agent_province",
      formTargetField: "attyProvince",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone",
      formTargetField: "attyPhone",
    },
    {
      profileFieldName: "new_profile_individual_agent_phone_ext",
      formTargetField: "attyPhoneext",
    },
    {
      profileFieldName: "new_profile_individual_agent_email",
      formTargetField: "attyEmail",
    },
    {
      profileFieldName: "new_profile_individual_agent_firm_name",
      formTargetField: "attyBizname",
    },
    {
      profileFieldName: "new_profile_individual_agent_firm_fein",
      formTargetField: "attyFein",
    },
    {
      profileFieldName: "new_profile_individual_agent_bar_number",
      formTargetField: "attyStatebarno",
    },
    {
      profileFieldName: "new_profile_individual_agent_court_state_id",
      formTargetField: "attyStatehighct",
    },
    {
      profileFieldName: "new_profile_individual_agent_court_name",
      formTargetField: "attyNamehighct",
    },
  ],
};
